import { Button, Input, UIHeading1, UIHeading5, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { IExpertOfferSuggestionsSchema } from 'shared/repositories/cian-chat-bot/entities/expert_opinion_offer/ExpertOfferSuggestionsSchema';

import * as styles from './ExpertOpinionBanner.css';
import avatar from './assets/avatar.png';
import { useFirstRowWidth } from './useFirstRowWidth';

export interface IExpertOpinionBannerProps {
  suggestions: IExpertOfferSuggestionsSchema[];
  textMessage: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: (text: string, displayText?: string) => void;
  onSuggestClick: (suggestion: IExpertOfferSuggestionsSchema) => void;
  onInputClick: () => void;
}

export const ExpertOpinionBanner = ({
  suggestions,
  textMessage,
  onInputChange,
  onClick,
  onSuggestClick,
  onInputClick,
}: IExpertOpinionBannerProps) => {
  const suggestionsBlockRef = React.useRef<HTMLDivElement>(null);
  const inputBlockWidth = Math.max(useFirstRowWidth(suggestionsBlockRef, 12) ?? 0, 325);

  return (
    <div className={styles['banner']}>
      <div>
        <UIHeading1>Спросите умного помощника</UIHeading1>
        <div className={styles['container']}>
          <UIText1>Получите экспертное мнение о жилье</UIText1>
          <div
            className={styles['input-block']}
            style={{ width: inputBlockWidth ? `${inputBlockWidth}px` : '100%' }}
            data-testid="input-block"
          >
            <Input
              size="M"
              placeholder="Расскажи мне про район"
              value={textMessage}
              onChange={onInputChange}
              onClick={onInputClick}
            />
            <Button onClick={() => onClick(textMessage)} data-testid="submit-button">
              Спросить
            </Button>
          </div>

          <div className={styles['suggestions-block']} ref={suggestionsBlockRef}>
            {suggestions.map((suggestion, index) => (
              <div
                data-testid={`suggestion_${index}`}
                key={index}
                className={styles['suggestion-item']}
                onClick={() => onSuggestClick(suggestion)}
              >
                <UIHeading5 color="control-main-primary-default">{suggestion.displayText}</UIHeading5>
              </div>
            ))}
          </div>
        </div>
      </div>
      <img src={avatar} width={130} height={130} />
    </div>
  );
};
